import * as React from "react";
import { cx } from "../util.js";
import { StatusBadge, type SceneStatus } from "./Badge.js";

export interface SceneCardProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  /** Scene title, e.g. "Scene 1 · On the Edge". */
  title: React.ReactNode;
  /** One- or two-line summary. */
  summary?: React.ReactNode;
  /** Scene status badge. */
  status?: SceneStatus;
  /** Meta row content (e.g. character/location Chips). */
  meta?: React.ReactNode;
}
/** Scene card for the grid/board (draggable in product use). */
export function SceneCard({ title, summary, status, meta, className, ...rest }: SceneCardProps) {
  return (
    <div className={cx("ip-scene", className)} {...rest}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: ".5rem", alignItems: "flex-start" }}>
        <h4 className="ip-scene-title">{title}</h4>
        {status && <StatusBadge status={status} />}
      </div>
      {summary && <p className="ip-scene-summary">{summary}</p>}
      {meta && <div className="ip-scene-meta">{meta}</div>}
    </div>
  );
}
